import React, { Fragment, useState, useRef } from "react";
import { Drawer, List, Modal, Input, Row, Col, Button, Alert, Typography, message } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import "../../style.css";
import "./styles.css";
import "../../globalStyles.css";
import { useWindowDimensions } from "../../../lib/useViewport";
import { useTranslation } from "react-i18next";
import {
  GiftCardValidateDrawer,
  GiftCardRedeemDrawer,
  CashManagementDrawer,
  CashManagementModal,
  CouponDrawer,
  LoyaltyOTPDrawer,
  ManualDiscountDrawer,
  BatchSelectionDrawer,
  ProductWeightModal,
  OMSOrdersModal,
  SalesTypeDrawer,
  CardPaymentModal,
  GiftCardSelectionDrawer,
  OfferSelectionModal,
  OfferDetailsModal,
  SideMenuDrawer,
  SelectBagDrawer,
  SalesRepresentativeModal,
  OffersDrawer,
  CardDetailsDrawer,
  LoyaltyOTPVerificationModal,
  OrderTypeSelectionModal,
  PaytmQRCodeModal,
  useRetailModalsLogic,
} from "./modals";
import DefaultProductImage from "../../../assets/images/no-image.svg";
import data from "../../../constants/retailPos.json";
import { validOtpCoupon, verifyCouponsService } from "../../../services";
import messages from "../../../errors/messages.en-IN.json";
import useCartStore from "../../../stores/useCartStore";
import useTransactionStore from "../../../stores/useTransactionStore";

const PointOfSaleRetailModals = (props) => {
  const {
    handleSelectedSaleTypeForProducts,
    handleSelectedRevenueCategory,
    changeCustomerId,
    saleTypeProducts,
    setSaleTypeProducts,
    cart,
    inputFocused,
    setInputFocused,
    displayOrderHistory,
    setDisplayOrderHistory,
    searchOrderHistory,
    showOrderHistory,
    setOrderHistoryInput,
    orderHistoryDetails,
    showOrderHistoryLine,
    selectedOrderHistoryLine,
    isPrintModeXML,
    syncOrders,
    displayParkedBillModal,
    closeParkedBillModal,
    handleParkedBillSearchInput,
    searchParkedBill,
    parkedBillSearchInput,
    filterdParkedList,
    selectParkedBill,
    displaySetOrderType,
    setDisplayOrderType,
    posSaleTypes,
    changeOrderType,
    displayOfferProductSelectiton,
    setDisplayOfferProductSelection,
    offerProductsList,
    selectOfferProduct,
    displayBatchSelection,
    setDisplayBatchSelection,
    batchSetAvailable,
    selectProductToCart,
    showManualBatchPopup,
    setShowManualBatchPopup,
    manualBatchNo,
    setManualBatchNo,
    manualBatchProduct,
    addManualBatchProduct,
    displayManualQtyWeightInput,
    setDisplayManualQtyWeightInput,
    callGetWeightAPI,
    currentWeightSelectedProduct,
    productWeightModalInput,
    onProductModalChangeWeight,
    addManualWeightToProduct,
    handleWeightManual,
    couponModalVisible,
    closeCouponModal,
    checkCoupon,
    setCouponInput,
    setLoyaltyInputValue,
    loyaltyInputValue,
    couponInput,
    handleCouponInput,
    handleLoyalityInput,
    loyalityOtpModalVisible,
    setLoyalityOtpModalVisible,
    loyaltyPaymentOtp,
    checkLoyality,
    processOtpInput,
    setLoyaltyPaymentOtp,
    displayOMSOrderItemsModal,
    omsOrderStatus,
    selectedOMSOrderStatus,
    setSelectedOrder,
    handleOMSOrderStatusSelection,
    order,
    handleOrderSearchInput,
    searchOrders,
    selectedOrder,
    handleOrderCard,
    tillData,
    handleOmsOrders,
    setDisplayOMSOrderItemsModal,
    handleOMSStatusButton,
    omsOrderTotalPrice,
    onClose,
    sideMenuDrawervisible,
    setSideMenuDrawervisible,
    salesRepModalOpen,
    setSalesRepModalOpen,
    handleSalesRepresentive,
    salesRepresentSearchInput,
    setSalesRepresentSearchInput,
    handleSalesRepresentSearchInput,
    filteredSalesRepresentList,
    manualDiscountModalVisible,
    setManualDiscountModalVisible,
    manualDiscountInput,
    setManualDiscountInput,
    manualDiscountTypes,
    setManualDiscountTypes,
    handleManualDiscountKeyPress,
    applyManualDiscount,
    selectedManualDiscountType,
    setSelectedManualDiscountType,
    setSelectedManualDiscountTypeValue,
    enableManualDiscountInput,
    setEnableManualDiscountInput,
    removeAllDiscounts,
    setProductWeightModalInput,
    paytmQrCodeModalOpens,
    setPaytmQrCodeModalOpens,
    qrCodeResponse,
    handleVerifyPayment,
    handleSalesReturnFromSideMenu,
    posConfig,
    onChangeCheckbox,
    setAddCashFlag,
    addCashFlag,
    orderHistorySearchInputRef,
    paymentModal,
    handleCahInOut,
    setCashAddInFlag,
    cashAddInFlag,
    cashManagementForm,
    handleCashInOutInput,
    fileInputRef,
    handleFileUpload,
    uploadedFileUrl,
    uploadedFileName,
    setUploadedFileUrl,
    setUploadedFileName,
    uploading,
    giftCardFlag,
    setGiftCardFlag,
    isGiftCardFlag,
    setIsGiftCardFlag,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    giftCardItems,
    setGiftCardItems,
    giftCardType,
    setGiftCardType,
    selectGiftCardItem,
    setSelectGiftCardItem,
    validateGiftCard,
    setValidateGiftCard,
    validateGiftCardForm,
    giftCardBalance,
    setGiftCardBalance,
    giftCardForm,
    CardPaymentForm,
    handleGiftCardDetails,
    handleGiftCard,
    redeemGiftCard,
    isSubmitting,
    setIsSubmitting,
    amount,
    setIsInputFocused,
    setCart,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    addToBagFlag,
    setAddToBagFlag,
    addToBagProducts,
    pickProduct,
    removeCoupon,
    isSaleTypeFlag,
    setIsSaleTypeFlag,
    showSaleType,
    setShowSaleType,
    selectedSaleType,
    setSelectedSaleType,
    selectedSaleTypeData,
    setSelectedSaleTypeData,
    isRevenueCategoryFlag,
    setIsRevenueCategoryFlag,
    selectedRevenueCategoryName,
    setSelectedRevenueCategoryName,
    revenueCategoryList,
    manualDiscountForm,
    handleTotalQty,
    selectedProductInCart,
    setSelectedProductInCart,
    onChangeTotalQuantity,
    enterTotalQty,
    open,
    setOpen,
    setKeyboardType,
    keyboardType,
    giftCardRef,
    searchTerm,
    setSearchTerm,
    layoutName,
    setLayoutName,
    getFilteredPaymentMethods,
    setShowPayments,
    selectBagRef,
    orderType,
    processBillDiscounts,
    openPaymentModalByCustomer,
    keyboard,
    inputName,
    setInputName,
    showProducts,
    setShowProducts,
    additionalInfo,
    setAdditionalInfo,
    additionalInfoForm,
    couponInfo,
    searchInputRef,
    totalBillDiscountData,
    setTotalBillDiscountData,
    discountAdditionalInfo,
    setDiscountAdditionalInfo,
    discountAdditionalInfoForm,
    processManualDiscount,
    discountInforApplication,
    cashIn,
    setCashIn,
    cashOut,
    setCashOut,
    pettyCashIn,
    setPettyCashIn,
    pettyCashOut,
    setPettyCashOut,
    bankTransfer,
    setBankTransfer,
    bankTransferDocument,
    setBankTransferDocument,
    uploadingDocs,
    setUploadingDocs,
    showCardPaymnteModal,
    setShowCardPaymnteModal,
    cardPaymnetError,
    setCardPaymnetError,
    cardPaymnetStatus,
    setCardPaymnetStatus,
    requestPayment,
    processOrder,
    setAmount,
    overPayedAmount,
    setOverPayedAmount,
    processCouponApplication,
    selectedCoupon,
    setSelectedCoupon,
    selectedExternalCouponType,
    setSelectedExternalCouponType,
    checkExternalCoupon,
    totalBillCouponData,
    setTotalBillCouponData,
    couponInputRef,
    redeemNumberRef,
    loyaltyInputRef,
    integratedPaymentStatus,
    setIntegratedPaymentStatus,
    offersDrawerOpen,
    setOffersDrawerOpen,
    setOnlineBatches,
    onlineBatches,
    fetchOnlineBatches,
    paymentType,
    setPaymentType,
    showCouponOtpPopup,
    setShowCouponOtpPopup,
    couponOtp,
    setCouponOtp,
    couponOtpError,
    setCouponOtpError,
    couponResendTimer,
    setCouponResendTimer,
    couponCanResend,
    setCouponCanResend,
    verificationCouponStatus,
    setVerificationCouponStatus,
    couponVerificationData,
    setCouponVerificationData,
    setDisplayAddNewCustomer,
    setDisplayEditOldCustomer,
    showCustomerWallet,
    setShowCustomerWallet,
    currentCardInput,
    setCurrentCardInput,
    enterTotalQtyForWallet,
    isNewGiftCardFlag,
    showGiftCardTopup,
    giftCardTopupPaymentMethod,
    setGiftCardTopupPaymentMethod,
    giftCardTopupCardInput,
    handleGiftCardTopupPostPayment,
    handleWalletPostPayment,
  } = props;

  const { Title, Text } = Typography;
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController || "{}");
  const tillLayout = parseInt(tillaccess?.layout);
  const [validOtpLoading, setValidOtpLoading] = useState(false);
  const inputsRef = useRef([]);

  const setDefaultImage = (e) => {
    e.target.src = DefaultProductImage;
  };

  const handleCouponOtpChange = (value, index) => {
    setCouponOtpError(false);
    if (!/^[0-9]?$/.test(value)) return;
    const newOtp = [...couponOtp];
    newOtp[index] = value;
    setCouponOtp(newOtp);
    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyCouponDown = (e, index) => {
    setCouponOtpError(false);
    if (e.key === "Backspace" && !couponOtp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handleVerifyCouponOtp = async () => {
    setValidOtpLoading(true);
    const otpValue = couponOtp.join("");
    const userData = JSON.parse(localStorage.getItem("userData")) || {};
    try {
      const validOtpResponse = await validOtpCoupon(
        userData?.user_id,
        otpValue,
        couponVerificationData?.verifyCoupons?.couponcode,
        couponVerificationData?.verifyCoupons?.mPricingRulesId
      );
      const status = validOtpResponse.data.data.validOtp.status;
      if (status === "200") {
        setVerificationCouponStatus(true);
        setTimeout(async () => {
          try {
            if (couponVerificationData) {
              await processCouponApplication(couponVerificationData.verifyCoupons, [couponVerificationData.pricingRules], couponVerificationData.uniqReferenceId);
              setDisplayAddNewCustomer(false);
              setDisplayEditOldCustomer(false);
            }
            setCouponOtp(Array(6).fill(""));
            setShowCouponOtpPopup(false);
            setVerificationCouponStatus(false);
            setCouponOtpError(false);
            setCouponResendTimer(0);
            setCouponCanResend(true);
            setValidOtpLoading(false);
          } catch (err) {
            console.error("Error applying coupon after OTP:", err);
            message.error("Error applying coupon. Please try again.");
            setVerificationCouponStatus(false);
            setCouponOtpError(true);
            setValidOtpLoading(false);
          }
        }, 500);
      } else if (status === "201") {
        setCouponOtpError(true);
        setValidOtpLoading(false);
      }
    } catch (err) {
      console.error(err);
      message.error(`${messages.info.invalid_otp}`);
      setValidOtpLoading(false);
    }
  };

  const verifyCoupons = async () => {
    try {
      if (!couponVerificationData) {
        message.error("Unable to resend OTP. Coupon data not found.");
        return;
      }
      const couponCode = couponVerificationData.verifyCoupons?.couponcode;
      const uniqReferenceId = couponVerificationData.uniqReferenceId;
      const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;
      const contactNo = cart?.customer?.mobileNo || cart?.customer?.phone;
      const pricingRuleId = couponVerificationData.verifyCoupons?.mPricingRulesId;
      if (!couponCode || !uniqReferenceId || !bunitId || !pricingRuleId) {
        message.error("Unable to resend OTP. Missing required information.");
        return;
      }
      const data = {
        query: `query{
          verifyCoupons(couponcode:"${couponCode}",referenceId: "${uniqReferenceId}",bunitId: "${bunitId}",contactNo: ${contactNo ? `"${contactNo}"` : null}, pricingRuleId: "${pricingRuleId}"){
            mPricingCouponId csClientId csBunitId created createdBy updated updatedBy line mPricingRulesId couponcode status redemptionCount usedDate upc otp
            additionalInfo { fieldName fieldType mandatory sequence displayLabel validationRule }
          }
        }`,
      };
      const response = await verifyCouponsService(data);
      if (response?.data?.data?.verifyCoupons?.length > 0) {
        const resendedCoupon = response.data.data.verifyCoupons[0];
        setCouponVerificationData({
          verifyCoupons: resendedCoupon,
          pricingRules: couponVerificationData.pricingRules,
          uniqReferenceId: couponVerificationData.uniqReferenceId,
        });
        message.success("OTP has been resent to your registered mobile number");
      } else {
        message.error("Failed to resend OTP. Please try again.");
      }
    } catch (error) {
      message.error("Failed to resend OTP. Please try again.");
    }
  };

  const handleResendCouponOtp = () => {
    setCouponResendTimer(30);
    setCouponCanResend(false);
    setVerificationCouponStatus(false);
    setCouponOtp(Array(6).fill(""));
    verifyCoupons();
    const interval = setInterval(() => {
      setCouponResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setCouponCanResend(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // Extract all logic (state, effects, handlers) into the hook
  const logic = useRetailModalsLogic({
    cart,
    setCart,
    inputFocused,
    setInputFocused,
    loyalityOtpModalVisible,
    loyaltyInputRef,
    loyaltyInputValue,
    setLoyaltyInputValue,
    setSelectedPaymentMethod,
    manualDiscountInput,
    setManualDiscountInput,
    selectedManualDiscountType,
    setSelectedManualDiscountType,
    setSelectedManualDiscountTypeValue,
    manualDiscountModalVisible,
    setTotalBillDiscountData,
    selectedExternalCouponType,
    couponModalVisible,
    selectedCoupon,
    setTotalBillCouponData,
    salesRepModalOpen,
    displayManualQtyWeightInput,
    setDisplayManualQtyWeightInput,
    setProductWeightModalInput,
    validateGiftCard,
    validateGiftCardForm,
    giftCardForm,
    giftCardFlag,
    amount,
    CardPaymentForm,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    giftCardBalance,
    addToBagFlag,
    selectBagRef,
    isGiftCardFlag,
    addCashFlag,
    cashAddInFlag,
    posConfig,
    setCashOut,
    setCashIn,
    setPettyCashOut,
    setPettyCashIn,
    cashManagementForm,
    showSaleType,
    selectedSaleType,
    setSelectedSaleType,
    setSelectedSaleTypeData,
    tillData,
    giftCardItems,
    searchTerm,
    giftCardType,
    addToBagProducts,
    setGiftCardItems,
    setSearchTerm,
    setGiftCardBalance,
    setSelectGiftCardItem,
    setIsGiftCardFlag,
    setValidateGiftCard,
    setIsSaleTypeFlag,
    changeCustomerId,
    getFilteredPaymentMethods,
    setShowPayments,
    orderType,
    processBillDiscounts,
    openPaymentModalByCustomer,
    manualDiscountTypes,
    searchInputRef,
    checkLoyality,
    removeCoupon,
    offersDrawerOpen,
  });

  const {
    showOtpPopup,
    setShowOtpPopup,
    offerDetailsOpen,
    setOfferDetailsOpen,
    selectedOffer,
    expenseCategories,
    financialAccounts,
    externalCoupons,
    selectedBatch,
    setSelectedBatch,
    selectedQty,
    setSelectedQty,
    saleTypeData,
    filteredGiftCards,
    filtredBags,
    focusedField,
    setFocusedField,
    amountInputRef,
    salesRepModalInputRef,
    authorizationRef,
    valueInputRef,
    handleCashManagement,
    handleAmountChange,
    handleCashInNote,
    selectGiftCard,
    handleAddGiftCardAmount,
    handleCardPayment,
    giftCardBalanceAmount,
    handleSelectedSaleType,
    errorMessage,
    verifyLoyalty,
    handleDiscountTypeChange,
    removeCouponConfirmation,
    modalTagMeta,
    formatDate,
    getDiscountText,
    handleViewDetails,
    getApplicableDays,
    compactTable,
    columns,
  } = logic;

  return (
    <Fragment>
      {/* ORDER TYPE SELECTION MODAL */}
      {displaySetOrderType && (
        <OrderTypeSelectionModal
          displaySetOrderType={displaySetOrderType}
          setDisplayOrderType={setDisplayOrderType}
          posSaleTypes={posSaleTypes}
          changeOrderType={changeOrderType}
        />
      )}

      {/* OFFER SELECTION MODAL */}
      {displayOfferProductSelectiton && (
        <OfferSelectionModal
          displayOfferProductSelectiton={displayOfferProductSelectiton}
          setDisplayOfferProductSelection={setDisplayOfferProductSelection}
          offerProductsList={offerProductsList}
          selectOfferProduct={selectOfferProduct}
          setDefaultImage={setDefaultImage}
        />
      )}

      {/* BATCH SELECTION */}
      {displayBatchSelection && (
        <BatchSelectionDrawer
          displayBatchSelection={displayBatchSelection}
          setDisplayBatchSelection={setDisplayBatchSelection}
          batchSetAvailable={batchSetAvailable}
          selectedBatch={selectedBatch}
          setSelectedBatch={setSelectedBatch}
          selectedQty={selectedQty}
          setSelectedQty={setSelectedQty}
          currenciesList={currenciesList}
          posConfig={posConfig}
          compactTable={compactTable}
          columns={columns}
          onlineBatches={onlineBatches}
          selectProductToCart={selectProductToCart}
        />
      )}

      {/* MANUAL BATCH ENTRY (receiptless returns) */}
      {showManualBatchPopup && (
        <Modal
          open={showManualBatchPopup}
          title={`Enter Batch Number — ${manualBatchProduct?.name || ""}`}
          okText="Add to Cart"
          onOk={addManualBatchProduct}
          onCancel={() => {
            setShowManualBatchPopup(false);
            setManualBatchNo("");
            const currentCart = useCartStore.getState().cart;
            if (currentCart?.isReturn === true && currentCart?.isBlindReceipt === true && (!currentCart?.items || currentCart.items.length === 0)) {
              const cleaned = { ...currentCart };
              delete cleaned.isReturn;
              delete cleaned.isBlindReceipt;
              setCart(cleaned);
              useTransactionStore.getState().setSelectedReturnType(null);
              useCartStore.getState().setExchangeCart(null);
              localStorage.removeItem("selectedReturnType");
              localStorage.removeItem("exchangeCartObj");
              if (typeof props.setFilterDrawer === "function") props.setFilterDrawer(false);
            }
          }}
          destroyOnClose
        >
          <Input placeholder="Batch Number" value={manualBatchNo} onChange={(e) => setManualBatchNo(e.target.value)} onPressEnter={addManualBatchProduct} autoFocus />
        </Modal>
      )}

      {/* PRODUCT WEIGHT MODAL */}
      {displayManualQtyWeightInput && (
        <ProductWeightModal
          displayManualQtyWeightInput={displayManualQtyWeightInput}
          setDisplayManualQtyWeightInput={setDisplayManualQtyWeightInput}
          selectedProductInCart={selectedProductInCart}
          cart={cart}
          callGetWeightAPI={callGetWeightAPI}
          setProductWeightModalInput={setProductWeightModalInput}
          onChangeTotalQuantity={onChangeTotalQuantity}
          setIsInputFocused={setIsInputFocused}
          enterTotalQty={enterTotalQty}
          handleTotalQty={handleTotalQty}
        />
      )}

      {/* COUPON MODAL */}
      {couponModalVisible && (
        <CouponDrawer
          couponModalVisible={couponModalVisible}
          closeCouponModal={closeCouponModal}
          additionalInfo={additionalInfo}
          setAdditionalInfo={setAdditionalInfo}
          additionalInfoForm={additionalInfoForm}
          couponInfo={couponInfo}
          externalCoupons={externalCoupons}
          selectedCoupon={selectedCoupon}
          setSelectedCoupon={setSelectedCoupon}
          selectedExternalCouponType={selectedExternalCouponType}
          setSelectedExternalCouponType={setSelectedExternalCouponType}
          couponInputRef={couponInputRef}
          couponInput={couponInput}
          setCouponInput={setCouponInput}
          setIsInputFocused={setIsInputFocused}
          manualDiscountInput={manualDiscountInput}
          setManualDiscountInput={setManualDiscountInput}
          handleCouponInput={handleCouponInput}
          checkCoupon={checkCoupon}
          checkExternalCoupon={checkExternalCoupon}
          tillData={tillData}
          totalBillDiscountData={totalBillDiscountData}
          cart={cart}
          width={width}
          removeCouponConfirmation={removeCouponConfirmation}
          searchInputRef={searchInputRef}
        />
      )}

      {/* LOYALTY OTP MODAL */}
      {loyalityOtpModalVisible && (
        <LoyaltyOTPDrawer
          loyalityOtpModalVisible={loyalityOtpModalVisible}
          setLoyalityOtpModalVisible={setLoyalityOtpModalVisible}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          setLoyaltyInputValue={setLoyaltyInputValue}
          loyaltyInputValue={loyaltyInputValue}
          cart={cart}
          loyaltyInputRef={loyaltyInputRef}
          showOtpPopup={showOtpPopup}
          posConfig={posConfig}
          verifyLoyalty={verifyLoyalty}
          checkLoyality={checkLoyality}
          handleLoyalityInput={handleLoyalityInput}
          width={width}
          t={t}
        />
      )}

      {/* OMS ORDERS MODAL */}
      {displayOMSOrderItemsModal && (
        <OMSOrdersModal
          displayOMSOrderItemsModal={displayOMSOrderItemsModal}
          setDisplayOMSOrderItemsModal={setDisplayOMSOrderItemsModal}
          omsOrderStatus={omsOrderStatus}
          selectedOMSOrderStatus={selectedOMSOrderStatus}
          selectedOrder={selectedOrder}
          setSelectedOrder={setSelectedOrder}
          handleOMSOrderStatusSelection={handleOMSOrderStatusSelection}
          searchOrders={searchOrders}
          order={order}
          handleOrderSearchInput={handleOrderSearchInput}
          handleOrderCard={handleOrderCard}
          omsOrderTotalPrice={omsOrderTotalPrice}
          currenciesList={currenciesList}
          tillData={tillData}
          data={data}
          handleOmsOrders={handleOmsOrders}
          handleOMSStatusButton={handleOMSStatusButton}
        />
      )}

      {/* SIDE MENU DRAWER */}
      {sideMenuDrawervisible && (
        <SideMenuDrawer
          sideMenuDrawervisible={sideMenuDrawervisible}
          onClose={onClose}
          handleOmsOrders={handleOmsOrders}
          cart={cart}
          posConfig={posConfig}
          handleSalesReturnFromSideMenu={handleSalesReturnFromSideMenu}
        />
      )}

      {/* SALES REPRESENTATIVE MODAL */}
      {salesRepModalOpen && (
        <SalesRepresentativeModal
          salesRepModalOpen={salesRepModalOpen}
          setSalesRepModalOpen={setSalesRepModalOpen}
          salesRepModalInputRef={salesRepModalInputRef}
          salesRepresentSearchInput={salesRepresentSearchInput}
          setSalesRepresentSearchInput={setSalesRepresentSearchInput}
          handleSalesRepresentSearchInput={handleSalesRepresentSearchInput}
          filteredSalesRepresentList={filteredSalesRepresentList}
          handleSalesRepresentive={handleSalesRepresentive}
        />
      )}

      {/* MANUAL DISCOUNT DRAWER */}
      {manualDiscountModalVisible && (
        <ManualDiscountDrawer
          manualDiscountModalVisible={manualDiscountModalVisible}
          setManualDiscountModalVisible={setManualDiscountModalVisible}
          manualDiscountForm={manualDiscountForm}
          manualDiscountInput={manualDiscountInput}
          setManualDiscountInput={setManualDiscountInput}
          manualDiscountTypes={manualDiscountTypes}
          handleManualDiscountKeyPress={handleManualDiscountKeyPress}
          applyManualDiscount={applyManualDiscount}
          selectedManualDiscountType={selectedManualDiscountType}
          setSelectedManualDiscountTypeValue={setSelectedManualDiscountTypeValue}
          enableManualDiscountInput={enableManualDiscountInput}
          removeAllDiscounts={removeAllDiscounts}
          selectedProductInCart={selectedProductInCart}
          setSelectedProductInCart={setSelectedProductInCart}
          cart={cart}
          tillData={tillData}
          totalBillDiscountData={totalBillDiscountData}
          discountAdditionalInfo={discountAdditionalInfo}
          setDiscountAdditionalInfo={setDiscountAdditionalInfo}
          discountAdditionalInfoForm={discountAdditionalInfoForm}
          discountInforApplication={discountInforApplication}
          handleDiscountTypeChange={handleDiscountTypeChange}
          valueInputRef={valueInputRef}
          searchInputRef={searchInputRef}
          width={width}
        />
      )}

      {/* OFFERS DRAWER */}
      {offersDrawerOpen && (
        <OffersDrawer offersDrawerOpen={offersDrawerOpen} setOffersDrawerOpen={setOffersDrawerOpen} handleViewDetails={handleViewDetails} formatDate={formatDate} />
      )}

      {/* OFFER DETAILS MODAL */}
      {offerDetailsOpen && (
        <OfferDetailsModal
          offerDetailsOpen={offerDetailsOpen}
          setOfferDetailsOpen={setOfferDetailsOpen}
          selectedOffer={selectedOffer}
          modalTagMeta={modalTagMeta}
          formatDate={formatDate}
          getDiscountText={getDiscountText}
          getApplicableDays={getApplicableDays}
        />
      )}

      {/* PAYTM QR CODE MODAL */}
      {paytmQrCodeModalOpens && (
        <PaytmQRCodeModal
          paytmQrCodeModalOpens={paytmQrCodeModalOpens}
          setPaytmQrCodeModalOpens={setPaytmQrCodeModalOpens}
          qrCodeResponse={qrCodeResponse}
          handleVerifyPayment={handleVerifyPayment}
        />
      )}

      {/* CASH MANAGEMENT DESKTOP MODAL */}
      {addCashFlag && (
        <CashManagementModal
          addCashFlag={addCashFlag}
          setAddCashFlag={setAddCashFlag}
          cashAddInFlag={cashAddInFlag}
          cashManagementForm={cashManagementForm}
          handleCahInOut={handleCahInOut}
          onChangeCheckbox={onChangeCheckbox}
          posConfig={posConfig}
          cashOut={cashOut}
          pettyCashIn={pettyCashIn}
          cashIn={cashIn}
          bankTransfer={bankTransfer}
          handleManualDiscountKeyPress={handleManualDiscountKeyPress}
        />
      )}

      {/* CASH MANAGEMENT BOTTOM DRAWER */}
      {addCashFlag && (
        <CashManagementDrawer
          addCashFlag={addCashFlag}
          setAddCashFlag={setAddCashFlag}
          cashAddInFlag={cashAddInFlag}
          cashManagementForm={cashManagementForm}
          handleCahInOut={handleCahInOut}
          onChangeCheckbox={onChangeCheckbox}
          posConfig={posConfig}
          cashOut={cashOut}
          setCashOut={setCashOut}
          pettyCashOut={pettyCashOut}
          setPettyCashOut={setPettyCashOut}
          bankTransfer={bankTransfer}
          cashIn={cashIn}
          setCashIn={setCashIn}
          pettyCashIn={pettyCashIn}
          setPettyCashIn={setPettyCashIn}
          expenseCategories={expenseCategories}
          financialAccounts={financialAccounts}
          handleCashManagement={handleCashManagement}
          handleAmountChange={handleAmountChange}
          handleCashInNote={handleCashInNote}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
          amountInputRef={amountInputRef}
          width={width}
          fileInputRef={fileInputRef}
          handleFileUpload={handleFileUpload}
          uploadedFileUrl={uploadedFileUrl}
          uploadedFileName={uploadedFileName}
          setUploadedFileUrl={setUploadedFileUrl}
          setUploadedFileName={setUploadedFileName}
          uploading={uploading}
        />
      )}

      {/* SELECT GIFT CARD */}
      {isGiftCardFlag && (
        <GiftCardSelectionDrawer
          isGiftCardFlag={isGiftCardFlag}
          setIsGiftCardFlag={setIsGiftCardFlag}
          giftCardType={giftCardType}
          setGiftCardType={setGiftCardType}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          setValidateGiftCard={setValidateGiftCard}
          setGiftCardBalance={setGiftCardBalance}
          setOpen={setOpen}
          setLayoutName={setLayoutName}
          searchInputRef={searchInputRef}
          selectBagRef={selectBagRef}
          filteredGiftCards={filteredGiftCards}
          selectGiftCard={selectGiftCard}
          keyboard={keyboard}
          setInputName={setInputName}
        />
      )}

      {/* SALE TYPE DRAWER */}
      {isSaleTypeFlag && (
        <SalesTypeDrawer
          isSaleTypeFlag={isSaleTypeFlag}
          setIsSaleTypeFlag={setIsSaleTypeFlag}
          saleTypeData={saleTypeData}
          tillLayout={tillLayout}
          searchInputRef={searchInputRef}
          handleSelectedSaleTypeForProducts={handleSelectedSaleTypeForProducts}
          handleSelectedSaleType={handleSelectedSaleType}
        />
      )}

      {/* VALIDATE GIFT CARD */}
      {validateGiftCard && (
        <GiftCardValidateDrawer
          validateGiftCard={validateGiftCard}
          setValidateGiftCard={setValidateGiftCard}
          validateGiftCardForm={validateGiftCardForm}
          handleGiftCardDetails={handleGiftCardDetails}
          giftCardType={giftCardType}
          setSearchTerm={setSearchTerm}
          setIsGiftCardFlag={setIsGiftCardFlag}
          setGiftCardBalance={setGiftCardBalance}
          giftCardBalance={giftCardBalance}
          setInputFocused={setInputFocused}
          inputFocused={inputFocused}
          selectGiftCardItem={selectGiftCardItem}
          cart={cart}
          handleAddGiftCardAmount={handleAddGiftCardAmount}
          giftCardBalanceAmount={giftCardBalanceAmount}
          errorMessage={errorMessage}
          currenciesList={currenciesList}
          width={width}
        />
      )}

      {/* REDEEM GIFT CARD */}
      {giftCardFlag && (
        <GiftCardRedeemDrawer
          giftCardFlag={giftCardFlag}
          setGiftCardFlag={setGiftCardFlag}
          giftCardForm={giftCardForm}
          redeemGiftCard={redeemGiftCard}
          selectedPaymentMethod={selectedPaymentMethod}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          setGiftCardBalance={setGiftCardBalance}
          giftCardBalance={giftCardBalance}
          setInputFocused={setInputFocused}
          inputFocused={inputFocused}
          handleGiftCard={handleGiftCard}
          handleAddGiftCardAmount={handleAddGiftCardAmount}
          cart={cart}
          amount={amount}
          isSubmitting={isSubmitting}
          redeemNumberRef={redeemNumberRef}
          width={width}
        />
      )}

      {/* CARD DETAILS DRAWER */}
      {isCardPaymentFlag && (
        <CardDetailsDrawer
          isCardPaymentFlag={isCardPaymentFlag}
          setIsCardPaymentFlag={setIsCardPaymentFlag}
          CardPaymentForm={CardPaymentForm}
          posConfig={posConfig}
          setInputFocused={setInputFocused}
          inputFocused={inputFocused}
          layoutName={layoutName}
          setLayoutName={setLayoutName}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          handleCardPayment={handleCardPayment}
          inputName={inputName}
        />
      )}

      {/* SELECT BAG DRAWER */}
      {addToBagFlag && (
        <SelectBagDrawer
          addToBagFlag={addToBagFlag}
          setAddToBagFlag={setAddToBagFlag}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          filtredBags={filtredBags}
          pickProduct={pickProduct}
          selectBagRef={selectBagRef}
          filteredGiftCards={filteredGiftCards}
          selectGiftCard={selectGiftCard}
          setKeyboardType={setKeyboardType}
          setOpen={setOpen}
          setLayoutName={setLayoutName}
        />
      )}

      {/* LOYALTY OTP VERIFICATION MODAL */}
      {showOtpPopup && (
        <LoyaltyOTPVerificationModal
          showOtpPopup={showOtpPopup}
          setShowOtpPopup={setShowOtpPopup}
          cart={cart}
          loyaltyInputValue={loyaltyInputValue}
          checkLoyality={checkLoyality}
          verifyLoyalty={verifyLoyalty}
        />
      )}

      {/* COUPON OTP VERIFICATION MODAL */}
      <Modal
        open={showCouponOtpPopup}
        footer={null}
        closable={false}
        centered
        bodyStyle={{ textAlign: "center", padding: "40px 24px" }}
        style={{ borderRadius: 8 }}
        afterOpenChange={(open) => {
          if (open) {
            setTimeout(() => { inputsRef.current[0]?.focus(); }, 50);
          }
        }}
      >
        <Title level={4} style={{ marginBottom: 8 }}>Verify OTP for Coupon</Title>
        <Text strong style={{ fontSize: 16 }}>Customer: {cart?.customer?.name}</Text>
        {verificationCouponStatus ? (
          <>
            <CheckCircleOutlined style={{ fontSize: "5rem", color: "green" }} />
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Alert type="success" message={<span style={{ color: "#166534" }}>Coupon successfully applied!</span>} showIcon
                style={{ backgroundColor: "#f0fdf4", border: "1px solid #bbf7d0", marginBottom: 20, width: "70%", height: 70, borderRadius: "0.5rem", marginTop: "2vh" }} />
            </div>
          </>
        ) : (
          <>
            <p style={{ color: "rgba(0,0,0,0.65)", marginBottom: 24 }}>Enter the 6-digit OTP sent to the customer's registered mobile number</p>
            <Row justify="center" gutter={8} style={{ marginBottom: 28 }}>
              {couponOtp.map((digit, idx) => (
                <Col key={idx}>
                  <Input autoFocus={idx === 0} maxLength={1} value={digit}
                    ref={(el) => (inputsRef.current[idx] = el)}
                    onChange={(e) => handleCouponOtpChange(e.target.value, idx)}
                    onKeyDown={(e) => handleKeyCouponDown(e, idx)}
                    style={{ width: 50, height: 50, textAlign: "center", fontSize: 20, borderRadius: 4 }} />
                </Col>
              ))}
            </Row>
            {couponOtpError && (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Alert type="error" message={<span style={{ color: "#991b1b" }}>Invalid OTP. Please check and try again.</span>} showIcon
                  style={{ backgroundColor: "#fff1f0", border: "1px solid #fecaca", color: "#cf1322", marginBottom: 20, width: "70%", height: 50, borderRadius: "0.5rem" }} />
              </div>
            )}
            <Row justify="center" gutter={16}>
              <Col>
                <Button onClick={() => { setShowCouponOtpPopup(false); setCouponOtp(Array(6).fill("")); setCouponOtpError(false); }} style={{ width: 100 }}>Cancel</Button>
              </Col>
              <Col>
                <Button type="primary" onClick={handleVerifyCouponOtp} style={{ width: 100 }} disabled={couponOtp.includes("") || validOtpLoading}>Verify OTP</Button>
              </Col>
            </Row>
            <div style={{ marginTop: 16 }}>
              <Button type="link" onClick={handleResendCouponOtp} disabled={!couponCanResend}>
                {couponCanResend ? "Resend OTP" : `Resend OTP in ${couponResendTimer}s`}
              </Button>
            </div>
          </>
        )}
      </Modal>

      {/* CARD PAYMENT MODAL */}
      {showCardPaymnteModal && (
        <CardPaymentModal
          showCardPaymnteModal={showCardPaymnteModal}
          setShowCardPaymnteModal={setShowCardPaymnteModal}
          cardPaymnetError={cardPaymnetError}
          setCardPaymnetError={setCardPaymnetError}
          cardPaymnetStatus={cardPaymnetStatus}
          setCardPaymnetStatus={setCardPaymnetStatus}
          paymentType={paymentType}
          setPaymentType={setPaymentType}
          selectedPaymentMethod={selectedPaymentMethod}
          amount={amount}
          CardPaymentForm={CardPaymentForm}
          integratedPaymentStatus={integratedPaymentStatus}
          currenciesList={currenciesList}
          cart={cart}
          setCart={setCart}
          posConfig={posConfig}
          data={data}
          setInputFocused={setInputFocused}
          handleCardPayment={handleCardPayment}
          requestPayment={requestPayment}
          processOrder={processOrder}
          setAmount={setAmount}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          overPayedAmount={overPayedAmount}
          tillData={tillData}
          setIsCardPaymentFlag={setIsCardPaymentFlag}
          showCustomerWallet={showCustomerWallet}
          enterTotalQtyForWallet={enterTotalQtyForWallet}
          isNewGiftCardFlag={isNewGiftCardFlag}
          showGiftCardTopup={showGiftCardTopup}
          giftCardTopupPaymentMethod={giftCardTopupPaymentMethod}
          setGiftCardTopupPaymentMethod={setGiftCardTopupPaymentMethod}
          giftCardTopupCardInput={giftCardTopupCardInput}
          handleGiftCardTopupPostPayment={handleGiftCardTopupPostPayment}
          handleWalletPostPayment={handleWalletPostPayment}
          currentCardInput={currentCardInput}
          setCurrentCardInput={setCurrentCardInput}
        />
      )}

      {/* REVENUE CATEGORY SELECTION */}
      <Drawer title="Select Revenue Category" placement="right" onClose={() => setIsRevenueCategoryFlag(false)} open={isRevenueCategoryFlag} width={350}>
        <List
          dataSource={revenueCategoryList || []}
          renderItem={(item) => (
            <List.Item
              onClick={() => handleSelectedRevenueCategory(item)}
              style={{
                cursor: "pointer",
                padding: "12px 16px",
                background: selectedRevenueCategoryName === item.name ? "#e6f7ff" : "transparent",
                borderRadius: "4px",
              }}
            >
              <List.Item.Meta title={item.name} description={item.isDefault === "Y" ? "Default" : ""} />
            </List.Item>
          )}
          locale={{ emptyText: "No revenue categories available" }}
        />
      </Drawer>
    </Fragment>
  );
};

export default PointOfSaleRetailModals;
